import React, { useState, useEffect } from "react";
import TabPane from "./Tabpane";
import styles from "./index.module.scss";
const Tabs = (props) => {
  const { children,active, setActive,changeTab,checkInit} = props;
  const [tabHeader, setTabHeader] = useState([]);
  const [childContent, setChildConent] = useState({});
  
  useEffect(() => {
    const headers = [];
    const childCnt = {};
    React.Children.forEach(children, (element) => {
      if (!React.isValidElement(element)) return;
      const { name } = element.props;
      headers.push(name);
      childCnt[name] = element.props.children;
    });
    setTabHeader(headers);
    checkInit && setActive(headers[0]);
    setChildConent({ ...childCnt });
  }, [props, children]);

  return (
    <div className="tabs col-md-11 col-xs-12">
      <ul className={styles.tab}>
        {tabHeader.map((item) => (
          <li
            onClick={() => changeTab(item)}
            key={item}
            
            className={(item === active) && styles["active"]}
          >
            {item}
          </li>
        ))}
      </ul>
      <div className="tab-content">
        {Object.keys(childContent).map((key) => {
          if (key === active) {
            return (
              <div class="tab-child" style={{ width: "100%" }}>
                {childContent[key]}
              </div>
            );
          } else {
            return null;
          }
        })}
      </div>
    </div>
  );
};

Tabs.propTypes = {
  children: function (props, propName, componentName) {
    const prop = props[propName];

    let error = null;
    React.Children.forEach(prop, function (child) {
      if (child.type !== TabPane) {
        error = new Error(
          "`" + componentName + "` children should be of type `TabPane`."
        );
      }
    });
    return error;
  },
};
export default Tabs;
